import { TYPES } from './actions';
import entity from './entity';

import { merge } from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_JOB_GROUP_REQUEST:
      if (action.payload.page === 1) {
        return merge(state, {
          ...INITIAL_STATE,
          isLoading: true,
        });
      }
      return merge(state, {
        error: null,
        isLoading: true,
      });
    case TYPES.GET_JOB_GROUP_SUCCESS:
      return merge(state, {
        data: merge(state.data, action.payload),
        error: null,
        isLoading: false,
      });
    case TYPES.GET_JOB_GROUP_FAILURE:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    case TYPES.CREATE_JOB_GROUP_REQUEST:
      return merge(state, {
        error: null,
        isLoading: true,
      });
    case TYPES.CREATE_JOB_GROUP_SUCCESS:
      return merge(state, {
        data: merge(state.data, action.payload),
        error: null,
        isLoading: false,
      });
    case TYPES.CREATE_JOB_GROUP_FAILURE:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    case TYPES.DELETE_JOB_GROUP_REQUEST:
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.DELETE_JOB_GROUP_SUCCESS:
      return merge(state, {
        isLoading: false,
        error: null,
      });
    case TYPES.DELETE_JOB_GROUP_FAILURE:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
